import { render, staticRenderFns } from "./SiniestralidadVariable.vue?vue&type=template&id=fede7b0c&scoped=true&"
import script from "./SiniestralidadVariable.vue?vue&type=script&lang=js&"
export * from "./SiniestralidadVariable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fede7b0c",
  null
  
)

export default component.exports